import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json'
const token = localStorage.getItem('token')
const firebase = localStorage.getItem('najva_user_token')
if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
if (firebase) axios.defaults.headers.common['Firebase'] = firebase
axios.interceptors.response.use(null, error => {
    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
    if (!expectedError) {
        return error.response
    }
    return Promise.reject(error)
})

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch,
}
